/**
 * Symbol je Meeting-/Termin-Typ — für die Marker im Projektplan-Gantt und in den
 * Arbeitspaket-Gantts. Die Typen entsprechen dem pm-api-ENUM (siehe MeetingDialog).
 * Unbekannte/leere Typen fallen auf das „Sonstige"-Symbol zurück.
 */
const SYMBOLS: Record<string, string> = {
  'Kick-Off': '🚀',
  'Lenkungskreis': '🧭',
  'Abnahme / Review': '✅',
  'Team Meeting': '👥',
  'Retrospektive': '🔄',
  'Phasenabschluss / Projektabschluss': '🏁',
  'Sonstige': '📌',
};

const FALLBACK = '📌';

/** Liefert das Symbol (Emoji) für einen Meeting-Typ. */
export function meetingTypeSymbol(typ: string | null | undefined): string {
  if (!typ) return FALLBACK;
  return SYMBOLS[typ] ?? FALLBACK;
}

/** Alle Typ→Symbol-Paare (für eine Legende). */
export function meetingTypeSymbolEntries(): Array<{ typ: string; symbol: string }> {
  return Object.entries(SYMBOLS).map(([typ, symbol]) => ({ typ, symbol }));
}
